<template>
  <v-app v-if="configLoaded">
    <RouterView />

    <global-snackbar />
  </v-app>

  <v-app v-else-if="configFailed">
    <v-main class="d-flex align-center justify-center">
      <v-alert
        type="error"
        variant="tonal"
        class="ma-4"
        max-width="600"
      >
        Die Seite kann gerade nicht geladen werden. Bitte versuchen Sie es in einigen Minuten erneut.
      </v-alert>
    </v-main>
  </v-app>
</template>

<script>
import { useUiStore } from '@/stores/ui.js'
import { useLocaleStore } from '@/stores/locale.js'

import Api from '@/api/api.js'
import keycloak from '@/plugins/keycloak.js'

import GlobalSnackbar from '@/components/GlobalSnackbar.vue'

export default {
  components: {
    GlobalSnackbar,
  },

  data () {
    return {
      configLoaded: false,
      configFailed: false,
      configPingInterval: null,
    }
  },

  /**
   * Unfortunately, we shouldn't use well-working .env-files for the app-config
   * and must load that from a public json-file. Since the config is required,
   * we can't start the app without it.
   *
   * @returns {Promise}
   */
  async beforeMount () {
    const config = await fetch('/config.json')
      .then(res => res.ok ? res.json() : null)
      .catch(() => null)

    if (config === null) {
      this.configFailed = true
      return console.error('could not load client-config.')
    }

    const { backend, oidc } = config
    Api.baseUrl = `${backend.url}api`
    keycloak.config = oidc

    // The UI settings of the API are optional: without them (API unreachable) the defaults apply
    await useUiStore().getConfig()
    useLocaleStore().initializeFromPath()

    this.configLoaded = true
    this.configPingInterval = setInterval(function () {
      useUiStore().getConfig()
    }, 10000)
  },

  unmounted () {
    clearInterval(this.configPingInterval)
  },
}
</script>

<style lang="scss">
  @import '@/styles/styles.scss';

  .v-main {
    background-color: #f4f6f9;
  }
</style>
